<template>
  <!--Dokumen Penambahan   -->
  <div class="row">
    <div class="col-12 spacer-field-sga">
      <p style="font-style:italic; color:red;">Ringkasan</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <LoadSpinner v-if="loading"/>
    </div>
    <div class="col-12 spacer-field-sga">
      <normal-label><i class="fa-solid fa-image"></i> Ringkasan Formulir</normal-label>
      <div class="custom-file">
        <textarea class="form-control textarea-sga" v-model="dataFormulir.ringkasan" rows="10" required=""></textarea>
        <keterangan-form>Silakan isi ringkasan formulir </keterangan-form>
      </div>
      <button class="btn btn-sm btn-success mt-2" @click="simpan">Simpan</button>
      {{message}}
    </div>
  </div>
</template>

<script>
//import "primevue/resources/themes/lara-light-indigo/theme.css";
import DashboardServices from "@/services/dashboard.services";
import LoadSpinner from "@/components/LoadSpinner";

export default {
  name: "PageFormDokumenRingkasan",
  props:{
    data:[],
    idanak:String,
    initdata: undefined,
    showupload: Boolean
  },
  components:{LoadSpinner},
  emits: ['change-data'],
  data:()=>({
    loading: false,
    urlupload: '',
    uploadprogress:0,
    classupload:'',
    uploadLabel: 'Pilih',
    isupload: false,
    success: false,
    message:"",
    response:"",
    dataFormulir:{
      ringkasan:'',
    }
  }),
  methods:{
    simpan(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        'invid': this.idanak,
        'ringkasan': this.dataFormulir,
        'formulir': this.initdata
      }
      let path = '/dashboard/updateFormulirPSBringkasan';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.data.message;
            if(response.data.status===200){
              this.success = true;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
  },
  mounted() {
    this.dataFormulir.ringkasan = this.initdata.dataRingkasan;
  },
}
</script>

<style scoped>

</style>